export function addAttributesToOuterLinks() {
    const links = Array.from(document.querySelectorAll('a[href^="http://"], a[href^="https://"]'));
    const currentHostname = window.location.hostname;

    links.forEach(function (link) {
        if (!link.href.includes(currentHostname)) {
            link.setAttribute("target", "_blank");
            link.setAttribute("rel", "nofollow");
        }

        if (link.href.endsWith(".pdf") || link.href.endsWith(".html")) {
            link.setAttribute("target", "_blank");
        }
    });
}

export function backToTop() {
    const backToTopButton = document.querySelector(".back-to-top");
    if (backToTopButton) {
        backToTopButton.addEventListener("click", function () {
            window.scrollTo({ top: 0, behavior: "smooth" });
        });
    }
}

export function anchorScroll(anchor, isDataAnchor = false) {

    const anchorButtons = Array.from(document.querySelectorAll(".btn-anchor"));
    anchorButtons.forEach(function (button) {
        let anchor = null;
        if (button.getAttribute("href") === null) {
            anchor = button.getAttribute("data-anchor");
        } else {
            anchor = button.getAttribute("href");
        }

        button.addEventListener("click", function () {
            gotoAnchor(anchor);
        });
    });

    if (window.location.hash) {
        // Rimuovo il carattere # e controllo se esiste un elemento con quell'id o un data-anchor
        let hash = window.location.hash.replace("#", "");

        setTimeout(function () {
            if (document.getElementById(hash) || document.querySelector(`[data-anchor="${hash}"]`)) {
                gotoAnchor(hash, true);
            }
        }, 100);
    }
    
}

function gotoAnchor(anchor, isDataAnchor = false) {
    if (isDataAnchor) {
        anchor = `[data-anchor="${anchor}"]`;
    }

    const targetElement = document.querySelector(anchor);
    if (targetElement) {
        const lenis = window.__lenis;
        if (lenis && typeof lenis.scrollTo === 'function') {
            lenis.scrollTo(targetElement, { duration: 1.2, easing: (t) => 1 - Math.pow(1 - t, 3) });
            return;
        }
        targetElement.scrollIntoView({ behavior: "smooth" });

    }
}
